import "./App.css";
import "./assets/css/style.css";
import "react-quill/dist/quill.snow.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { ToastContextProvider } from "./context/ToastContext";
import AuthorizationRoute from "./utils/AuthorizationRoute";
import Login from "./pages/Login";
import Home from "./pages/Home";
import User from "./pages/users/User";
import SubAdmin from "./pages/sub_admin/SubAdmin";
import Company from "./pages/company_manager/Company";
import TransactionManager from "./pages/transaction_manager/TransactionManager";
import Settings from "./pages/settings/Settings";
import Subscriptions from "./pages/subscription_manager/Subscription";

import Faq from "./pages/static_content/FAQ";
import AboutUs from "./pages/static_content/AboutUs";
import ContactUs from "./pages/static_content/ContactUs";
import PrivatePolicy from "./pages/static_content/PrivatePolicy";
import TermsAndConditions from "./pages/static_content/TermsAndConditions";
import Profile from "pages/profile/Profile";
import ForgotPassword from "pages/auth/ForgotPassword";
import ResetPassword from "pages/auth/ResetPassword";
import ChangePassword from "pages/auth/ChangePassword";
import UnderDevelopment from "components/UnderDevelopment";
import SharedLayout from "utils/SharedLayout";
import ProtectedRoute from "utils/ProtectedRoute";
import PropertyTypes from "pages/property_type_manager/PropertyTypes";
import PropertyCategory from "pages/property_category_manager/PropertyCategory";
import Amenities from "pages/amenities/Amenities";
import TopBarMenus from "pages/menus_manager/TopBarMenus";
import Auction from "pages/auction_manager/Auction";
import Bid from "pages/bid_manager/Bid";
import Meeting from "pages/meeting_manager/Meeting";
import Notification from "pages/notification_manager/Notification";
import Marketing from "pages/marketing_manager/Marketing";
import Ads from "pages/ads_manager/Ads";
import Properties from "pages/property_manager/Properties";
import AddProperty from "pages/property_manager/AddProperty";
import Agent from "pages/agents_manager/Agent";
import Approval from "pages/approval_manager/Approval";
import Query from "pages/query_manager/Query";
import Blog from "pages/blog_manager/Blog";
import BlogPage from "pages/blog_manager/BlogPage";
import CustomerViewPage from "pages/users/CustomerViewPage";
import CompanyViewPage from "pages/company_manager/CompanyViewPage";
import AgentViewPage from "pages/agents_manager/AgentViewPage";
import ReportManager from "pages/reports/ReportManager";
import UnitsReport from "pages/reports/units_report/UnitsReport";
import ProjectManager from "pages/project_manager/ProjectManager";
import AddProject from "pages/project_manager/AddProject";
import ViewProject from "pages/project_manager/ViewProject";
import ProjectHistory from "pages/project_manager/ProjectHistory";
import AuctionStatus from "pages/auction_manager/auctions_status/AuctionStatus";
import PropertyViewNew from "pages/property_manager/PropertyViewListNew";
import BellNotifications from "pages/notification_manager/BellNotifications";
import ProjectView from "pages/project_manager/ProjectView";
import ReasonReport from "pages/reason_report/ReasonReport";
import City from "pages/address_manager/City";
import MortgageSetting from "pages/mortgage/MorgageSetting";
import AgentDetailViewPage from "pages/company_manager/company_view_details/AgentDetailViewPage";
import PageNotFound from "components/PageNotFound";
import PropertyCategorySequence from "pages/property_category_manager/PropertyCategorySequence";
import UnitManager from "pages/unit_manager/UnitManager";
import AddUnit from "pages/unit_manager/AddUnit";
import UnitDetail from "pages/unit_manager/UnitDetail";
import EditUnit from "pages/unit_manager/EditUnit";
import UnitHistory from "pages/unit_manager/UnitHistory";
import CommunityManger from "pages/community_manager/CommunityManger";
import AddCommunity from "pages/community_manager/AddCommunity";
import CommunityDetail from "pages/community_manager/CommunityDetail";
import EditCommunity from "pages/community_manager/EditCommunity";
import ProjectStatusManger from "pages/project_status_manager/ProjectStatusManger";
import AddProjectStatus from "pages/project_status_manager/AddProjectStatus";
import ProjectStatusDetail from "pages/project_status_manager/ProjectStatusDetail";
import EditProjectStatus from "pages/project_status_manager/EditProjectStatus";
import HomeMenuManager from "pages/app_home_menu_manager/HomeMenuManager";
import AddHomeMenu from "pages/app_home_menu_manager/AddHomeMenu";
import HomeMenuDetail from "pages/app_home_menu_manager/HomeMenuDetail";
import EditHomeMenu from "pages/app_home_menu_manager/EditHomeMenu";
import Orders from "pages/order_manager/Orders";
import OrderDiscounts from "pages/order_manager/OrderDiscounts";
import Careers from "pages/careers/Careers";
import CareerForm from "pages/careers/CareerForm";
import CareerView from "pages/careers/CareerView";
import Applications from "pages/careers/Applications";
import ApplicationView from "pages/careers/ApplicationView";
import ResumeCatalog from "pages/careers/ResumeCatalog";
import Recruiters from "pages/careers/Recruiters";
import OnboardingCandidates from "pages/onboarding_candidates/OnboardingCandidates";
import OnboardingCandidateDetails from "pages/onboarding_candidates/OnboardingCandidateDetails";
import ProjectFloorManager from "pages/project_floors_manager/ProjectFloorManager";
import AddProjectFloor from "pages/project_floors_manager/AddProjectFloor";
import ImportUnit from "pages/unit_manager/ImportUnit";
import TestManager from "pages/test_manager/TestManager";
import QuestionBankPage from "pages/test_manager/views/question-bank";
import QuestionsPage from "pages/test_manager/views/questions";
import TestsPage from "pages/test_manager/views/tests-pages";
import TestEditPage from "pages/test_manager/views/tests-pages/edit-test";
import AddTestPage from "pages/test_manager/views/tests-pages/add-test";
import AddQuestionBankPage from "pages/test_manager/views/question-bank/add-question-bank";
import TestSubmissionsPage from "pages/test_manager/views/submissions";
import SubmissionDetailsPage from "pages/test_manager/views/submissions/submission-details";
import TestDetailsPage from "pages/test_manager/views/tests-pages/test-details";
import ImportFAQ from "pages/static_content/ImportFAQ";
import BankManagerPage from "pages/bank_manager/view";
import AddEditBankPage from "pages/bank_manager/view/AddEditBankPage";
import TrainingSessions from "pages/training_session_manager/TrainingSessions";
import AddTrainingSession from "pages/training_session_manager/AddTrainingSession";
import TrainingSubmissions from "pages/training_session_manager/submissions";
import TrainingSubmissionDetails from "pages/training_session_manager/submissions/SubmissionDetails";
import ActivityOverview from "pages/activity_tracker/Overview";
import ActivityFeed from "pages/activity_tracker/Feed";
import ActivityAgentDetail from "pages/activity_tracker/AgentDetail";

function App() {
  return (
    <BrowserRouter>
      <ToastContextProvider>
        <AuthProvider>
          <Routes>
            <Route element={<SharedLayout />}>
              <Route exact path="/dashboard" element={<Home />} />
              <Route exact path="/bank-manager" element={<BankManagerPage />} />
              <Route
                exact
                path="/bank-manager/bank/:id"
                element={<AddEditBankPage />}
              />
              <Route
                exact
                path="/bank-manager/bank"
                element={<AddEditBankPage />}
              />
              <Route path="*" element={<PageNotFound />} />
              <Route
                exact
                path="/users"
                element={
                  <AuthorizationRoute>
                    <User />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/users/view"
                element={
                  <AuthorizationRoute>
                    <CustomerViewPage />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/sub-admin-manager"
                element={
                  <AuthorizationRoute>
                    <SubAdmin />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/static/faqs"
                element={
                  <AuthorizationRoute>
                    <Faq />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/static/faqs/import-faqs"
                element={
                  <AuthorizationRoute>
                    <ImportFAQ />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/static/about-us"
                element={
                  <AuthorizationRoute>
                    <AboutUs />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/static/contact-us"
                element={
                  <AuthorizationRoute>
                    <ContactUs />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/auction"
                element={
                  <AuthorizationRoute>
                    <Auction />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/units"
                element={
                  <AuthorizationRoute>
                    <UnitManager />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/community"
                element={
                  <AuthorizationRoute>
                    <CommunityManger />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/project-status"
                element={
                  <AuthorizationRoute>
                    <ProjectStatusManger />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/app-home-menu"
                element={
                  <AuthorizationRoute>
                    <HomeMenuManager />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/units/import-units"
                element={
                  <AuthorizationRoute>
                    <ImportUnit />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/units/detail"
                element={
                  <AuthorizationRoute>
                    <UnitDetail />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/units/add-unit"
                element={
                  <AuthorizationRoute>
                    <AddUnit />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/units/edit-unit/:Id"
                element={
                  <AuthorizationRoute>
                    <EditUnit />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/units/history/:id"
                element={
                  <AuthorizationRoute>
                    <UnitHistory />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/community/add-community"
                element={
                  <AuthorizationRoute>
                    <AddCommunity />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/project-status/add"
                element={
                  <AuthorizationRoute>
                    <AddProjectStatus />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/app-home-menu/add"
                element={
                  <AuthorizationRoute>
                    <AddHomeMenu />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="auction/add-property"
                element={
                  <AuthorizationRoute>
                    <AddProperty />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="auction/edit-property/:Id"
                element={
                  <AuthorizationRoute>
                    <AddProperty />
                  </AuthorizationRoute>
                }
              />
              {/* <Route
                exact
                path='/auction/view/:Id'
                element={
                  <AuthorizationRoute>
                    <OPropertyView />
                  </AuthorizationRoute>
                }
              /> */}
              <Route
                exact
                path="/auction/view/:Id"
                element={
                  <AuthorizationRoute>
                    <PropertyViewNew />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/auction/status"
                element={
                  <AuthorizationRoute>
                    <AuctionStatus />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/bids"
                element={
                  <AuthorizationRoute>
                    <Bid />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/transactions"
                element={
                  <AuthorizationRoute>
                    <TransactionManager />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/subscriptions"
                element={
                  <AuthorizationRoute>
                    <Subscriptions />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/meetings"
                element={
                  <AuthorizationRoute>
                    <Meeting />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/activity-tracker"
                element={
                  <AuthorizationRoute>
                    <ActivityOverview />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/activity-tracker/feed"
                element={
                  <AuthorizationRoute>
                    <ActivityFeed />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/activity-tracker/agents/:agentId"
                element={
                  <AuthorizationRoute>
                    <ActivityAgentDetail />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/training-sessions"
                element={
                  <AuthorizationRoute>
                    <TrainingSessions />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/training-sessions/add"
                element={
                  <AuthorizationRoute>
                    <AddTrainingSession />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/training-sessions/edit/:id"
                element={
                  <AuthorizationRoute>
                    <AddTrainingSession />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/training-sessions/submissions"
                element={
                  <AuthorizationRoute>
                    <TrainingSubmissions />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/training-sessions/submissions/details/:id"
                element={
                  <AuthorizationRoute>
                    <TrainingSubmissionDetails />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/notifications"
                element={
                  <AuthorizationRoute>
                    <Notification />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/notification-list"
                element={
                  <ProtectedRoute>
                    <BellNotifications />
                  </ProtectedRoute>
                }
              />
              <Route
                exact
                path="/marketing-material"
                element={
                  <AuthorizationRoute>
                    <Marketing />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/ads"
                element={
                  <AuthorizationRoute>
                    <Ads />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/report-reason"
                element={
                  <AuthorizationRoute>
                    <ReasonReport />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/reports"
                element={
                  <AuthorizationRoute>
                    <ReportManager />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/units-report"
                element={
                  <AuthorizationRoute>
                    <UnitsReport />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/test-manager"
                element={
                  <AuthorizationRoute>
                    <TestManager />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/test-manager/add-test"
                element={
                  <AuthorizationRoute>
                    <AddTestPage />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/test-manager/tests"
                element={
                  <AuthorizationRoute>
                    <TestsPage />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/test-manager/tests/edit/:id"
                element={
                  <AuthorizationRoute>
                    <TestEditPage />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/test-manager/tests/details/:id"
                element={
                  <AuthorizationRoute>
                    <TestDetailsPage />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/test-manager/question-bank/add"
                element={
                  <AuthorizationRoute>
                    <AddQuestionBankPage />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/test-manager/submissions"
                element={
                  <AuthorizationRoute>
                    <TestSubmissionsPage />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/test-manager/submissions/details/:id"
                element={
                  <AuthorizationRoute>
                    <SubmissionDetailsPage />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/test-manager/questions"
                element={
                  <AuthorizationRoute>
                    <QuestionsPage />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/test-manager/question-bank"
                element={
                  <AuthorizationRoute>
                    <QuestionBankPage />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/properties"
                element={
                  <AuthorizationRoute>
                    <Properties />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/properties/add-property"
                element={
                  <AuthorizationRoute>
                    <AddProperty />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/properties/edit-property/:Id"
                element={
                  <AuthorizationRoute>
                    <AddProperty />
                  </AuthorizationRoute>
                }
              />
              {/* <Route
                exact
                path='/properties/view/:Id'
                element={
                  <AuthorizationRoute>
                    <OPropertyView />
                  </AuthorizationRoute>
                }
              /> */}
              <Route
                exact
                path="/properties/view/:Id"
                element={
                  <AuthorizationRoute>
                    <PropertyViewNew />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/projects"
                element={
                  <AuthorizationRoute>
                    <ProjectManager />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/projects/add-project"
                element={
                  <AuthorizationRoute>
                    <AddProject />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/projects/view"
                element={
                  <AuthorizationRoute>
                    <ViewProject />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/projects/viewNew"
                element={
                  <AuthorizationRoute>
                    <ProjectView />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/projects/edit-project/:Id"
                element={
                  <AuthorizationRoute>
                    <AddProject />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/projects/history/:id"
                element={
                  <AuthorizationRoute>
                    <ProjectHistory />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/project-floors"
                element={
                  <AuthorizationRoute>
                    <ProjectFloorManager />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/project-floors/add-project-floor"
                element={
                  <AuthorizationRoute>
                    <AddProjectFloor />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/project-floors/edit-project-floor/:Id"
                element={
                  <AuthorizationRoute>
                    <AddProjectFloor />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/orders"
                element={
                  <AuthorizationRoute>
                    <Orders />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/order-discounts"
                element={
                  <AuthorizationRoute>
                    <OrderDiscounts />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/careers"
                element={
                  <AuthorizationRoute>
                    <Careers />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/careers/add"
                element={
                  <AuthorizationRoute>
                    <CareerForm />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/careers/edit/:id"
                element={
                  <AuthorizationRoute>
                    <CareerForm />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/careers/view/:id"
                element={
                  <AuthorizationRoute>
                    <CareerView />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/careers/applications"
                element={
                  <AuthorizationRoute>
                    <Applications />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/careers/resume-catalog"
                element={
                  <AuthorizationRoute>
                    <ResumeCatalog />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/careers/applications/view/:id"
                element={
                  <AuthorizationRoute>
                    <ApplicationView />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/careers/recruiters"
                element={
                  <AuthorizationRoute>
                    <Recruiters />
                  </AuthorizationRoute>
                }
              />
              <Route
                path="/onboarding-requests"
                element={
                  <ProtectedRoute title="O_ONBOARDING_CANDIDATES" module="onboarding_candidates">
                    <OnboardingCandidates />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/onboarding-requests/view/:id"
                element={
                  <ProtectedRoute title="O_ONBOARDING_CANDIDATES" module="onboarding_candidates">
                    <OnboardingCandidateDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                exact
                path="/agents"
                element={
                  <AuthorizationRoute>
                    <Agent />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/agents/view"
                element={
                  <AuthorizationRoute>
                    <AgentViewPage />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/approval-manager"
                element={
                  <AuthorizationRoute>
                    <Approval />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/query-manager"
                element={
                  <AuthorizationRoute>
                    <Query />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/blogs"
                element={
                  <AuthorizationRoute>
                    <Blog />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/city"
                element={
                  <AuthorizationRoute>
                    <City />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/city/community"
                element={
                  <AuthorizationRoute>
                    <City />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/city/subCommunity"
                element={
                  <AuthorizationRoute>
                    <City />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/blogs/add-blog"
                element={
                  <AuthorizationRoute>
                    <BlogPage />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/blogs/Edit-blog"
                element={
                  <AuthorizationRoute>
                    <BlogPage />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/static/terms-and-conditions"
                element={
                  <AuthorizationRoute>
                    <TermsAndConditions />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/static/privacy-policy"
                element={
                  <AuthorizationRoute>
                    <PrivatePolicy />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/settings"
                element={
                  <AuthorizationRoute>
                    <Settings />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/mortgageSettings"
                element={
                  <AuthorizationRoute>
                    <MortgageSetting />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/transaction-manager"
                element={
                  <AuthorizationRoute>
                    <TransactionManager />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/property-types"
                element={
                  <AuthorizationRoute>
                    <PropertyTypes />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/property-categories"
                element={
                  <AuthorizationRoute>
                    <PropertyCategory />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/property-categories-sequence"
                element={
                  <AuthorizationRoute>
                    <PropertyCategorySequence />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/amenities"
                element={
                  <AuthorizationRoute>
                    <Amenities />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/top-menus"
                element={
                  <AuthorizationRoute>
                    <TopBarMenus />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />

              <Route
                exact
                path="/company"
                element={
                  <AuthorizationRoute>
                    <Company />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/company/view"
                element={
                  <AuthorizationRoute>
                    <CompanyViewPage />
                  </AuthorizationRoute>
                }
              />
              {/* <Route
                exact
                path='/company/agent/view'
                element={
                  <AuthorizationRoute>
                    <AgentDetailViewPage />
                  </AuthorizationRoute>
                }
              /> */}

              <Route
                exact
                path="/change-password"
                element={
                  <ProtectedRoute>
                    <ChangePassword />
                  </ProtectedRoute>
                }
              />

              <Route
                exact
                path="/aml"
                element={
                  <AuthorizationRoute>
                    <UnderDevelopment />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/community-detail"
                element={
                  <AuthorizationRoute>
                    <CommunityDetail />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/edit-community"
                element={
                  <AuthorizationRoute>
                    <EditCommunity />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/project-status-detail"
                element={
                  <AuthorizationRoute>
                    <ProjectStatusDetail />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/edit-project-status"
                element={
                  <AuthorizationRoute>
                    <EditProjectStatus />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/app-home-menu/detail"
                element={
                  <AuthorizationRoute>
                    <HomeMenuDetail />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/app-home-menu/edit"
                element={
                  <AuthorizationRoute>
                    <EditHomeMenu />
                  </AuthorizationRoute>
                }
              />
            </Route>
            <Route exact path="/" element={<Login />} />
            <Route exact path="/login" element={<Login />} />

            <Route exact path="/forgot-password" element={<ForgotPassword />} />

            <Route
              exact
              path="/reset-password/:resetToken"
              element={<ResetPassword />}
            />
          </Routes>
        </AuthProvider>
      </ToastContextProvider>
    </BrowserRouter>
  );
}

export default App;
